import { NgTemplateOutlet } from "@angular/common";
import { ChangeDetectionStrategy, Component, input, output, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AutoComplete } from "primeng/autocomplete";
import { FloatLabel } from "primeng/floatlabel";
import { FormControlBaseDirective } from "../form-control-base.directive";

let nextId = 0;

@Component({
    selector: "kno2-form-autocomplete",
    imports: [FormsModule, AutoComplete, FloatLabel, NgTemplateOutlet],
    templateUrl: "./form-autocomplete.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormAutocompleteComponent extends FormControlBaseDirective {
    public readonly suggestions = input<string[]>([]);
    public readonly placeholder = input<string>();
    public readonly inputId = input<string>(`kno2-form-autocomplete-${nextId++}`);
    public readonly complete = output<string>();

    protected readonly value = signal<string>("");

    protected applyValue(value: unknown): void {
        this.value.set((value as string) ?? "");
    }

    protected handleChange(value: string): void {
        this.value.set(value);
        this.emitChange(value);
    }
}
